import { StatRow } from 'oas';
import { calculateLoadScores } from 'reporting/helpers';
import { AverageSetsModel, StatType } from 'reporting/types';

export const transformStats = (stats: StatRow[], averageSets: AverageSetsModel, statType: StatType): StatRow[] => {
    return calculateLoadScores(stats, averageSets, statType);
};
